<template>
  <router-link class="navbar-brand" style="line-height: 16px;" :to="{ name: 'home' }">
    {{ $t('common.app_name') }}
  </router-link>
</template>

<script setup>
import { colors } from '../../../../consts/colors';

const props = defineProps({
  appEnv: {
    type: String,
    required: true,
  },
});

</script>

<style lang="scss" scoped>
.navbar-brand {
  color: v-bind('colors.textPrimary');
  font-weight: 600;
}
</style>
